import { Theme } from '@livecontrol/core-ui';
import { Phone } from '@livecontrol/locale-us';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';

import G = Matrix.Grid;
import H = G.Header;
import C = G.Row.Cell;

interface Props {
  users: {
    id: string;
    name: string;
    email: string;
    priority: string;
    phoneNumber: string;
    contactMethod: string;
  }[];
}

export const UserGrid = ({ users }: Props): React.ReactElement => {
  const viewport = Theme.useViewport();

  return (
    <G viewport={viewport} className='row-gap-4px' gridTemplateColumns='repeat(5, 1fr)'>
      {/* Header */}
      <G.Row>
        <H viewport={viewport}>Priority</H>
        <H viewport={viewport}>Name</H>
        <H viewport={viewport}>Email</H>
        <H viewport={viewport}>Phone Number</H>
        <H viewport={viewport}>Preference</H>
      </G.Row>

      {
        /* Content */
        users.map(
          (user): React.ReactElement => (
            <G.Row key={user.id}>
              <C>{user.priority}</C>
              <C>{user.name}</C>
              <C>{user.email}</C>
              <C>
                {Phone.normalize(user.phoneNumber)?.format({ parenthetical: true }) ??
                  user.phoneNumber}
              </C>
              <C>{user.contactMethod}</C>
            </G.Row>
          )
        )
      }
    </G>
  );
};
